import React from 'react'
import Main from '../../cpn/Main'
import {Col, Divider, Row} from 'antd'
import LedgerTableDept from './LedgerTableDept'
import LedgerTableClient from './LedgerTableClient'
import LedgerTableClientType from './LedgerTableClientType'
import LedgerTableGoods from './LedgerTableGoods'
import LedgerTableGoodsType from './LedgerTableGoodsType'
import LedgerTableOperator from './LedgerTableOperator'
import LedgerTableSalesman from './LedgerTableSalesman'
import LedgerTableArapDept from './LedgerTableArapDept'
import LedgerTableArapClient from './LedgerTableArapClient'
import LedgerTableArapStatement from './LedgerTableArapStatement'
//
import ArapTableDept from './ArapTableDept'
import ArapTableClient from './ArapTableClient'
import ArapTableClientType from './ArapTableClientType'
import ArapTableGoods from './ArapTableGoods'
import ArapTableGoodsType from './ArapTableGoodsType'
import ArapTableOperator from './ArapTableOperator'
import ArapTableSalesman from './ArapTableSalesman'
//
import FundTableDept from './FundTableDept';
import FundTableClient from './FundTableClient';
import FundTableClientType from './FundTableClientType';
import FundTableGoods from './FundTableGoods';
import FundTableGoodsType from './FundTableGoodsType';
import FundTableOperator from './FundTableOperator';
import FundTableSalesman from '../statForm/FundTableSalesman';
function StatIndex() {    
    return (
        <Main  t1='统计报表'>
            <Row gutter={20}>
                <Col span={6}>
                    <Divider>待下账</Divider>
                    <Row>
                        <LedgerTableArapDept />                              
                        <LedgerTableArapClient />                              
                        <LedgerTableArapStatement /> 
                    </Row>
                </Col> 
                <Col span={6}>
                    <Divider>部门利润汇总</Divider>
                    <Row>
                        <LedgerTableDept />
                        <ArapTableDept />
                        <FundTableDept /> 
                    </Row>
                </Col>
                <Col span={6}>
                    <Divider>操作员利润汇总</Divider>
                    <Row>
                        <LedgerTableOperator />  
                        <ArapTableOperator /> 
                        <FundTableOperator />
                    </Row>
                </Col>
                <Col span={6}>
                    <Divider>销售员利润汇总</Divider>
                    <Row>
                        <LedgerTableSalesman />  
                        <ArapTableSalesman />   
                        <FundTableSalesman />  
                    </Row>
                </Col>               
            </Row>
            <Row gutter={20}>                
                <Col span={6}>
                    <Divider>客户利润汇总</Divider>
                    <Row>
                        <LedgerTableClient />  
                        <ArapTableClient /> 
                        <FundTableClient /> 
                    </Row>
                </Col>
                <Col span={6}>
                    <Divider>客户类型利润汇总</Divider>
                    <Row>
                        <LedgerTableClientType />  
                        <ArapTableClientType /> 
                        <FundTableClientType />
                    </Row>
                </Col>
                <Col span={6}>
                    <Divider>产品利润汇总</Divider>
                    <Row>
                        <LedgerTableGoods />  
                        <ArapTableGoods  />
                        <FundTableGoods />
                    </Row>
                </Col>
                <Col span={6}>
                    <Divider>产品类型利润汇总</Divider>
                    <Row>
                        <LedgerTableGoodsType /> 
                        <ArapTableGoodsType />  
                        <FundTableGoodsType />
                    </Row>
                </Col>
            </Row>            
        </Main>
    )
}

export default StatIndex